<ion-content class="background">
  <div [ngClass]="{'ios-space-top': platform.is('ios')}"></div>
  <div class="sub-title-2">
    <ion-label>Datos del Paciente</ion-label>
  </div>

  <ion-grid class="content-resume">
    <ion-row>
      <ion-col>
        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce text-label">
            <ion-label color="tertiary"
              >Apellidos:
              <span class="t-bold">{{data.patientInfo.last_name}} </span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce text-label">
            <ion-label color="tertiary"
              >Nombres:
              <span class="t-bold"> {{data.patientInfo.first_name}}</span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none" *ngIf="data.patientInfo.email != ''">
          <ion-label color="tertiary" class="t-ce text-label">
            <ion-label color="tertiary"
              >Correo electrónico:
              <span class="t-bold"> {{data.patientInfo.email}}</span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none" *ngIf="data.patientInfo.birth_day != ''">
          <ion-label color="tertiary" class="t-ce text-label">
            <ion-label color="tertiary"
              >Fecha de nacimiento (AAAA-MM-DD):
              <span class="t-bold">{{data.patientInfo.birth_day}} </span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce text-label">
            <ion-label color="tertiary"
              >Identificación:
              <span class="t-bold">{{data.patientInfo.identification}} </span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce text-label">
            <ion-label color="tertiary"
              >Género:
              <span class="t-bold">{{data.patientInfo.gender | gender}} </span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce text-label">
            <ion-label color="tertiary">
              {{ "Provincia" | translate }} :
              <span class="t-bold">{{data.patientInfo.state_name}}</span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce text-label">
            <ion-label color="tertiary"
              >{{"Localidad" | translate }}:
              <span class="t-bold">{{data.patientInfo.city_name}}</span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none" *ngIf="this.data.patientInfo.address != ''">
          <ion-label color="tertiary" class="t-ce text-label">
            <ion-label color="tertiary"
              >Dirección:
              <span class="t-bold">{{data.patientInfo.address}}</span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce text-label">
            <ion-label color="tertiary"
              >Teléfono 1
              <span class="messages-alert"
                >(Del paciente, Familiar o Tutor)</span
              >:
              <span class="t-bold"
                > ({{data.patientInfo.prefix_cell_phone}}) -{{data.patientInfo.cell_phone}}
              </span>
            </ion-label>
          </ion-label>
        </ion-item>

        <div *ngIf="this.data.patientInfo.cell_phone_2 != ''">
          <ion-item lines="none">
            <ion-label color="tertiary" class="t-ce text-label">
              <ion-label color="tertiary"
                >Teléfono 2
                <span class="messages-alert">
                  (Del paciente, Familiar o Tutor)</span
                >:
                <span class="t-bold"
                  > ({{data.patientInfo.prefix_cell_phone2}}) - {{data.patientInfo.cell_phone_2}}
                </span>
              </ion-label>
            </ion-label>
          </ion-item>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="sub-title-2">
    <ion-label>Datos de la Solicitud</ion-label>
  </div>

  <ion-grid class="content-resume">
    <ion-row>

      <ion-col>

        <ion-item lines="none" *ngIf="data.comments">
          <ion-label color="tertiary">
            <ion-label color="tertiary">
              Comentarios:
              <span class="t-bold"> {{data.comments}} </span>
            </ion-label>
          </ion-label>
        </ion-item>

        <div class="w-100 my-2 mx-4 separator"></div>
        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce text-label">
            <ion-label class="h2 t-bold" color="primary"
              >Manifestaciones
            </ion-label>
          </ion-label>
        </ion-item>

        <div *ngIf="data.manifests.length > 0">
          <div *ngFor="let manifest of data.manifests">
            <ion-item lines="none" class="t-ce text-label">
              <ion-label color="tertiary" class="t-ce text-label t-bold">
                <ion-icon
                  name="checkmark"
                  color="primary"
                  slot="start"
                  class="t-ce text-label"
                ></ion-icon>
                {{manifest.manifest_name}}</ion-label
              >
            </ion-item>
          </div>
        </div>

        <div class="w-100 my-2 mx-4 separator"></div>
        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce text-label">
            <ion-label class="h2 t-bold" color="primary"
              >Tipo de Estudio
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none" class="t-ce text-label">
          <ion-label color="tertiary" class="t-ce text-label t-bold">
            <ion-icon
              name="checkmark"
              color="primary"
              slot="start"
              class="t-ce text-label t-bold"
            ></ion-icon>
            {{data.study_type_name}}</ion-label
          >
        </ion-item>

        <div class="w-100 my-2 mx-4 separator"></div>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce text-label">
            <ion-label class="h2 t-bold" color="primary"
              >Pruebas a Realizar
            </ion-label>
          </ion-label>
        </ion-item>

        <div *ngIf="data.test_types.length > 0">
          <div *ngFor="let test of data.test_types">
            <ion-item lines="none" class="t-ce text-label">
              <ion-label color="tertiary" class="t-ce text-label t-bold">
                <ion-icon
                  name="checkmark"
                  color="primary"
                  slot="start"
                  class="t-ce text-label"
                ></ion-icon>
                {{test.test_types_name}}
                <span *ngIf="test.observation != ''" class="t-bold"
                  >| {{test.observation}}
                </span></ion-label
              >
            </ion-item>
          </div>
        </div>

        <div class="w-100 my-2 mx-4 separator"></div>

        <ion-item *ngIf="data.laboratory" lines="none">
          <ion-label color="tertiary" class="t-ce text-label">
            <ion-label class="h2 t-bold" color="primary"
              >Laboratorio de análisis
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item *ngIf="data.laboratory" lines="none" class="t-ce text-label">
          <ion-label color="tertiary" class="t-ce text-label t-bold">
            <ion-icon
              name="checkmark"
              color="primary"
              slot="start"
              class="t-ce text-label t-bold"
            ></ion-icon>
            {{data.laboratory}}</ion-label
          >
        </ion-item>

        <div class="w-100 my-2 mx-4 separator"></div>

        <div>
          <ion-item lines="none">
            <ion-label color="tertiary" class="t-ce text-label">
              <ion-label class="h2 t-bold" color="primary"
                >Rastreo Muestra
              </ion-label>
            </ion-label>
          </ion-item>

          <div>
            <div *ngFor="let event of data.events">
              <ion-item
                lines="none"
                class="t-ce text-label"
                *ngIf="event.created_date.length > 0"
              >
                <ion-label color="tertiary" class="t-ce text-label t-bold">
                  <span>{{event.created_date}}</span>

                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <span>{{event.event_name}}</span>
                  <br />
                  <span class="text-observation">{{event.observation}}</span>
                </ion-label>
              </ion-item>
            </div>
          </div>
        </div>

        <div>
          <ion-item lines="none" *ngIf="files.length > 0">
            <ion-label color="tertiary" class="t-ce text-label">
              <ion-label class="h2 t-bold" color="primary"
                >Resultados
              </ion-label>
            </ion-label>
          </ion-item>

          <div>
            <div *ngFor="let file of files">
              <div *ngIf="files.length > 0">
                <ion-item lines="none" class="t-ce text-label">
                  <ion-label color="tertiary" class="t-ce text-label t-bold">
                    <span
                      >Archivo: {{file.name}}
                      <ion-button (click)="download(file.id)" fill="clear">
                        <ion-icon
                          slot="end"
                          name="download-outline"
                        ></ion-icon> </ion-button
                    ></span>
                  </ion-label>
                </ion-item>
                <ion-item lines="none">
                  <ion-label color="tertiary" class="t-ce text-label">
                    <ion-label color="tertiary"
                      >Resultados:
                      <span class="t-bold"> {{file.result == 'Ninguna' || file.result == '' ? 'No hay observacion adicional disponible': file.result}}</span>
                    </ion-label>
                  </ion-label>
                </ion-item>
                <ion-item lines="none">
                  <ion-label color="tertiary" class="t-ce text-label">
                    <ion-label color="tertiary"
                      >Observaciones:
                      <span class="t-bold"> {{file.notes == 'Ninguna' || file.result == '' ? 'No hay observacion adicional disponible': file.notes}}</span>
                    </ion-label>
                  </ion-label>
                </ion-item>
              </div>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- Input Botones -->
  <ion-grid>
    <ion-row style="margin-top: 1rem !important">
      <ion-col class="ion-text-center btn-message" size="12">
        <app-btn-support [message]="messageSupport"></app-btn-support>
      </ion-col>

      <ion-col class="ion-text-center" size="12">
        <button
          (click)="closeModal()"
          id="btn-close-modal"
          class="btn-primary btn-close"
        >
          Cerrar
        </button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
